import { Controller } from 'stimulus'

export default class extends Controller {
	connect() {
		this.frame = this.element.querySelector('turbo-frame')
		this.onFrameLoad = this.onFrameLoad.bind(this)
		this.onHidden = this.onHidden.bind(this)

		if (this.frame) {
			this.frame.addEventListener('turbo:frame-load', this.onFrameLoad)
		}
		$(this.element).on('hidden.bs.modal', this.onHidden)
	}

	disconnect() {
		if (this.frame) {
			this.frame.removeEventListener('turbo:frame-load', this.onFrameLoad)
		}
		$(this.element).off('hidden.bs.modal', this.onHidden)
	}

	onFrameLoad() {
		$(this.element).modal('show')
	}

	onHidden() {
		if (!this.frame) return

		this.frame.removeAttribute('src')
		this.frame.innerHTML = ''
	}

	hideOnSuccess(event) {
		if (!event.detail.success) return
		$(this.element).modal('hide')
	}
}